<div class="card card-outline card-primary">
    <div class="card-header text-center">
        <img src="assets/img/logo.png" width="50"><br/>
        <a [routerLink]="['/']" class="h1">Linguwa</a>
    </div>
    <div class="card-body">
        <p class="login-box-msg">Admin panel giriş</p>

        <form [formGroup]="loginForm" (ngSubmit)="loginByAuth()">
            <div class="input-group mb-3">
                <input
                    formControlName="email"
                    type="email"
                    class="form-control"
                    placeholder="Email"
                />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <span class="fas fa-envelope"></span>
                    </div>
                </div>
            </div>
            <div class="input-group mb-3">
                <input
                    formControlName="password"
                    type="password"
                    class="form-control"
                    placeholder="Parola"
                />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <span class="fas fa-lock"></span>
                    </div>
                </div>
            </div>
            <div class="row">
              
                <!-- /.col -->
                <div class="col-12">
                    <pf-button
                        [type]="'submit'"
                        [block]="true"
                        [loading]="isAuthLoading"
                       
                    >
                 Giriş Yap
                    </pf-button>
                </div>
                <!-- /.col -->
            </div>
        </form>

      
        <p class="mb-1">
            <a [routerLink]="['/forgot-password']">Şifremi unuttum</a>
        </p>
      
    </div>
    <!-- /.login-card-body -->
</div>
